import ArrowDownIcon from "@pages/profile-v2/assets/icons/ArrowDownIcon.jsx";
import CopyIcon from "@pages/profile-v2/assets/icons/CopyIcon.jsx";
import { parseId } from "@pages/profile-v2/utils";
import { copyToClipboard, getCurrencySymbol } from "@utils";
import moment from "moment";
import React, { useState } from "react";
import {
	Amount,
	BonusInfo,
	ButtonText,
	ContentBody,
	ContentDescription,
	ContentFooter,
	ContentHeader,
	ContentWrapper,
	CopyId,
	Date,
	Description,
	DetailsButton,
	FooterIdInfoWrapper,
	FooterInfoWrapper,
	HeaderTitle,
	Id,
	Note,
	PaybackInfo,
	Status,
} from "./elements";

const GameContent = ({ data, translate }) => {
	const [openDetailsIndex, setOpenDetailsIndex] = useState(null);

	return data?.reports?.map((report, index) => {
		const areDetailsOpen = openDetailsIndex === index;

		return (
			<ContentWrapper key={index}>
				<ContentHeader>
					<Date>
						{moment(Number(report?.submissionTime_id?.split("#")[0])).format(
							"YYYY-MM-DD HH:mm"
						)}
					</Date>
					<HeaderTitle>
						{report?.couponId
							? `SPORTSBOOK ${translate("GAME")}`
							: report?.roundId
								? `CASINO ${translate("GAME")}`
								: ""}
					</HeaderTitle>
				</ContentHeader>
				<ContentBody>
					<Amount>
						{translate("BET AMOUNT")}:{" "}
						{report?.walletContributions &&
						report?.walletContributions.length > 0 &&
						report?.walletContributions[0].amount.currency === "FreeSpin Token" ? (
							<>
								{report?.walletContributions[0]?.amount?.value ?? "-"}{" "}
								{report?.walletContributions[0]?.amount?.currency}{" "}
							</>
						) : (
							<>
								{getCurrencySymbol(
									report?.walletContributions[0]?.amount?.currency
								)}{" "}
								{report?.walletContributions[0]?.amount?.value ?? "-"}
							</>
						)}
					</Amount>
					<Status status={report?.type || report?.transactionType?.split("#")[1]}>
						{report?.type
							? report?.type
							: report?.transactionType
								? report?.transactionType?.split("#")[1]
								: ""}
					</Status>
				</ContentBody>
				<ContentDescription>
					<Description>
						{translate("BALANCE AFTER TRANSACTION")}:{" "}
						{report?.walletContributions &&
							report?.walletContributions.length > 0 &&
							getCurrencySymbol(report?.walletContributions[0].amount.currency)}{" "}
						{report?.balanceAfterTransaction ?? "-"}{" "}
					</Description>
				</ContentDescription>
				{areDetailsOpen ? (
					window.PROFILE_HISTORY_HAS_IDS ? (
						<ContentFooter>
							<FooterIdInfoWrapper>
								<CopyId hasIds={window.PROFILE_HISTORY_HAS_IDS}>
									<CopyIcon
										onClick={() =>
											copyToClipboard(
												(report?.roundId || report?.couponId) &&
													report?.couponId
													? report?.couponId.split("#")[1]
													: report?.roundId
														? report?.roundId
																?.split("#")
																?.filter((part) => /\d/.test(part))
																?.join(" ")
														: "",
												translate
											)
										}
									/>
									{report?.couponId
										? translate("COUPON_ID")
										: report?.roundId
											? translate("ROUND_ID")
											: ""}
									<Id>
										{parseId(
											(report?.roundId || report?.couponId) &&
												report?.couponId
												? report?.couponId.split("#")[1]
												: report?.roundId
													? report?.roundId
															?.split("#")
															?.filter((part) => /\d/.test(part))
															?.join(" ")
													: "",
											5
										)}
									</Id>
								</CopyId>
								<CopyId hasIds={window.PROFILE_HISTORY_HAS_IDS}>
									<CopyIcon
										onClick={() =>
											copyToClipboard(
												report?.transactionId && report?.transactionId,
												translate
											)
										}
									/>
									{translate("TRANSACTION_ID")}: {""}
									<Id>
										{parseId(report?.transactionId && report?.transactionId, 5)}
									</Id>
								</CopyId>
							</FooterIdInfoWrapper>
							<FooterInfoWrapper hasIds={window.PROFILE_HISTORY_HAS_IDS}>
								<BonusInfo>
									{translate("BONUS")}:{" "}
									{report?.walletContributions?.length > 0 &&
									report?.walletContributions[0]?.walletType == "Real"
										? "NO"
										: "YES"}
								</BonusInfo>
								<PaybackInfo>
									{translate("PAYBACK")}:{" "}
									{report?.transactionType &&
									report?.transactionType?.split("#")[1] == "Rollback"
										? translate("YES")
										: translate("NO")}
								</PaybackInfo>
							</FooterInfoWrapper>
							<Note>
								{translate("NOTE")}:{" "}
								{report?.note ? report?.note : translate("THERE IS NO NOTE")}
							</Note>
						</ContentFooter>
					) : (
						<ContentFooter>
							<FooterInfoWrapper>
								<CopyId>
									<CopyIcon
										onClick={() =>
											copyToClipboard(
												(report?.roundId || report?.couponId) &&
													report?.couponId
													? report?.couponId.split("#")[1]
													: report?.roundId
														? report?.roundId
																?.split("#")
																?.filter((part) => /\d/.test(part))
																?.join(" ")
														: "",
												translate
											)
										}
									/>
									{translate("COL-ID")}: {""}
									<Id>
										{parseId(
											(report?.roundId || report?.couponId) &&
												report?.couponId
												? report?.couponId.split("#")[1]
												: report?.roundId
													? report?.roundId
															?.split("#")
															?.filter((part) => /\d/.test(part))
															?.join(" ")
													: "",
											5
										)}
									</Id>
								</CopyId>
								<BonusInfo>
									{translate("BONUS")}:{" "}
									{report?.walletContributions?.length > 0 &&
									report?.walletContributions[0]?.walletType == "Real"
										? "NO"
										: "YES"}
								</BonusInfo>
								<PaybackInfo>
									{translate("PAYBACK")}:{" "}
									{report?.transactionType &&
									report?.transactionType?.split("#")[1] == "Rollback"
										? translate("YES")
										: translate("NO")}
								</PaybackInfo>
							</FooterInfoWrapper>
							<Note>
								{translate("NOTE")}:{" "}
								{report?.note ? report?.note : translate("THERE IS NO NOTE")}
							</Note>
						</ContentFooter>
					)
				) : null}
				<DetailsButton
					rotate={areDetailsOpen}
					onClick={() => setOpenDetailsIndex(areDetailsOpen ? null : index)}>
					<ButtonText>
						{!areDetailsOpen ? translate("DETAILS") : translate("HIDE")}
					</ButtonText>
					<ArrowDownIcon />
				</DetailsButton>
			</ContentWrapper>
		);
	});
};

export default GameContent;
